module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f0744b_logo_200x200.9e67a522.png";